import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProtectedSharePageRoutingModule } from './protected-share-routing.module';

import { ProtectedSharePage } from './protected-share.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProtectedSharePageRoutingModule
  ],
  declarations: [ProtectedSharePage]
})
export class ProtectedSharePageModule {}
